<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index;">
        <ng-container *appHasAnyAuthority="item.authorities!">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        </ng-container>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
